/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Transcript_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Delete this transcript event" |
*
* @param {Event_Delete_Transcript_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_transcript_aria_label = /** @type {((inputs?: Event_Delete_Transcript_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Transcript_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer cet evenement de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Transkript löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina questo evento di trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить это событие из стенограммы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar este evento de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除此转录事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このトランスクリプトイベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस ट्रांसक्रिप्ट इवेंट को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir este evento de transcrição")
	return /** @type {LocalizedString} */ ("Delete this transcript event")
});